export const iconFontAwesomeLogisticsSailboat = (
	<i className="fa-solid fa-sailboat"></i>
);
